import { BaseModel } from "./BaseModel";


export default class JurisdictionGroup extends BaseModel {

    id: number;
    watershedManagementGroupId: number;
    jurisdictionId: number;
    isLead: number;
    active: number;
    editor: string;
    created: Date;
    updated: Date;

    constructor() {
        super("JurisdictionGroup", "local")
    }
}